import { useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { getPageMeta } from "@/lib/navConfig";

/** Inline "access denied" panel, shown in place of a page the user cannot open. */
export function NoPermissionContent() {
  const { pathname } = useLocation();
  const pageTitle = getPageMeta(pathname)?.title;

  return (
    <section className="page-panel flex flex-1 flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <ShieldAlert className="size-6 text-muted-foreground" aria-hidden="true" />
      <h2 className="text-base font-semibold text-foreground">Access denied</h2>
      <p className="max-w-prose text-sm text-muted-foreground">
        You don&apos;t have permission to view{" "}
        {pageTitle ? <strong className="font-medium text-foreground">{pageTitle}</strong> : "this page"}.
        Contact your administrator if you think this is a mistake.
      </p>
    </section>
  );
}
